function CoordDetails(props) {
  const { name, number } = props;
  return (
    <div className={"coord-details"}>
      <p className={"coord-name"}>{name}</p>
      <p className={"coord-number"}>{number}</p>
    </div>
  );
}

export default CoordDetails;
